import { createTheme } from '@mui/material';

export const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: '#3b82f6' },
        secondary: { main: '#10b981' },
        background: {
            default: '#050510',
            paper: 'rgba(30, 30, 45, 0.7)',
        },
        text: {
            primary: '#ffffff',
            secondary: '#ffffff',
        },
    },
    typography: {
        fontFamily: "'Outfit', sans-serif",
        h5: { fontWeight: 700 },
        h6: { fontWeight: 600 },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: { borderRadius: 12, textTransform: 'none', fontWeight: 600 },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    background: 'rgba(255, 255, 255, 0.03)',
                },
            },
        },
        MuiCssBaseline: {
            styleOverrides: {
                body: { color: '#ffffff' }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    backdropFilter: 'blur(15px)',
                    background: 'rgba(15, 15, 25, 0.8)',
                    border: '1px solid rgba(255, 255, 255, 0.05)',
                },
            },
        },
    },
});
